<template>
  <div class="weekly-goods" :class="{boxSty: !noStyle}" @click="goIndexDetail(item)">
    <a style="background-color: pink;">
      <p class="weekly-goods-icon-1" v-if="item.favorites_type === 0">
        <span>
          <img src="static\img\index\img\icon_6(1).png" alt=""
            @click.stop="handleCollect(item, 1, index, ...collectParams)" />
        </span>
      </p>
      <!--收藏后变颜色-->
      <p class="weekly-goods-icon-2" v-if="item.favorites_type === 1">
        <span>
          <img src="static\img\index\img\icon_7.png" alt=""
            @click.stop="handleCollect(item, 2, index, ...collectParams)" />
        </span>
      </p>
      <!--收藏后变颜色-->
      <div class="weekly-goods-img">
        <img class="move-img" :src="item.goods_img ||
          'static/img/goodsList/goods_default_img.jpg'
          " :onerror="defaultGoodsImg" alt="图片破损" />
        <div class="frame-img" v-if="item.frame !== ''">
          <img :src="item.frame" alt="" />
        </div>
      </div>
<!--      <p class="weekly-goods-loginPrice">-->
<!--        <span class="weekly-price" v-if="item[priceProp] !== ''">-->
<!--          ￥{{ item[priceProp] }}/{{ item.unit }}-->
<!--        </span>-->
<!--        <span class="weekly-price" v-else-if="item.selling_price !== ''">-->
<!--          ￥{{ item.selling_price }}/{{ item.unit }}-->
<!--        </span>-->
<!--        <span class="weekly-old-price" v-if="item[priceProp] !== item.original_price">-->
<!--          <s>￥{{ item.original_price }}</s>-->
<!--        </span>-->
<!--      </p>-->
      <p class="weekly-goods-loginPrice">
        <!-- 账期用户显示原价 -->
        <span class="weekly-price" v-if="item.is_credit_user == 1 && item.original_price !== ''">
          ￥{{ item.original_price }}/{{ item.unit }}
        </span>
              <!-- 非账期用户按原有逻辑显示 -->
              <span class="weekly-price" v-else-if="item[priceProp] !== ''">
          ￥{{ item[priceProp] }}/{{ item.unit }}
        </span>
              <span class="weekly-price" v-else-if="item.selling_price !== ''">
          ￥{{ item.selling_price }}/{{ item.unit }}
        </span>
              <!-- 非账期用户显示原价作为对比 -->
              <span class="weekly-old-price" v-if="item.is_credit_user != 1 && item[priceProp] !== item.original_price">
          <s>￥{{ item.original_price }}</s>
        </span>
      </p>


      <p class="goods-zsm" v-if="item.is_zsm === 1">
        <span class="badge">有追溯码</span>
      </p>

<!--      <p class="weekly-goods-intro">{{ item.goods_name }}</p>-->
      <!-- 商品名称 -->
      <p class="weekly-goods-intro">
        <img v-if="item.can_give_bean === 1" src="/static/img/pointsmall/image/jindou.png" alt="金豆" class="bean-icon" />
        {{ item.goods_name }}
      </p>

      <!--  <p class="weekly-goods-spec">{{ item.manufacturer_name }}</p>
      <p class="weekly-goods-spec">效期：<span style="color: red;">{{ item.expiration_date }}</span></p>-->
      <p class="weekly-goods-spec">规格：{{ item.specification }}</p>
      <!-- <p class="weekly-goods-noLogin" v-show="!userInfo.username">价格登录可见</p>-->
      <div class="goods-bottom-icon">
        <p v-for="(label, index) in getLabels(item.lables)" :class="{
          'pro-more-1': index === 0,
          'pro-more-2': index === 1,
          'pro-more-3': index === 2,
          'pro-more-4': index === 3,
        }" :key="index">
          {{ goodsLabelSet[label] }}
        </p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "HomeShop",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    goIndexDetail: {
      type: Function,
    },
    defaultGoodsImg: {
      type: String,
    },
    goodsLabelSet: {
      type: Object,
      default: () => ({})
    },
    handleCollect: {
      typeof: Function,
      default: () => () => {}
    },
    collectParams: {
      type: Array,
      default: () => []
    },
    priceProp: { // 价格的字段
      type: String,
      default: "selling_price"
    },
    noStyle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getLabels(labels) {
      if (labels) {
        return labels.split(",").length > 4
          ? labels.split(",").slice(3)
          : labels.split(",");
      } else {
        return ['0']
      }
    },
  },
}
</script>

<style lang="less" scoped>
.weekly-goods {
  position: relative;
  cursor: pointer;
  // background-color: pink;
}
.boxSty {
  width: 230px;
  // width: 19%;
  // height: 350px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
  box-shadow: 0px 4px 8px 0px rgba(179, 179, 179, 0.2);
  margin-bottom: 15px;
  // margin-right: 12px;
  padding: 20px 17px;
}

.weekly-goods-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(180deg, #ff4367 0%, #fe5789 100%);
  box-shadow: 0px 2px 6px 0px rgba(184, 18, 50, 0.2);
  font-size: 16px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 10px;
  z-index: 2;
}

.weekly-goods-icon-1 {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  display: none;
  z-index: 2;

  span {
    line-height: 33px;
  }
}

.weekly-goods:hover .weekly-goods-icon-1 {
  display: block;
}

.weekly-goods-icon-2 {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  display: none;
  z-index: 10;

  span {
    line-height: 33px;
  }
}

.weekly-goods:hover .weekly-goods-icon-2 {
  display: block;
}

.weekly-goods-img {
  width: 190px;
  // --height: 140px;
  height: 140px;
  margin: auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  img {
    width: 180px;
    --height: 140px;
  }

  .move-img:hover {
    /* transform: translateY(-5px);
        transition-duration: 1s;*/
  }

  .frame-img {
    position: absolute;
    top: 0;
    left: 0;
  }

}

.weekly-goods-intro {
  font-size: 18px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 600;
  color: #111;
  padding: 0 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.weekly-goods-spec {
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  text-shadow: 0px 2px 6px rgba(220,220,220,0.3);
  text-align: left;
  padding-top: 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-left: 3px;
}

.weekly-goods-noLogin {
  font-size: 20px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 600;
  color: #fa0000;
  padding-top: 8px;
}

.weekly-goods-loginPrice {
  padding-top: 8px;

  .weekly-price {
    font-size: 20px;
    font-family: PingFangHK-Medium, PingFangHK;
    font-weight: 600;
    color: #fa0000;
    line-height: 20px;
  }

  .weekly-old-price {
    font-size: 14px;
    color: #CCCCCC;
    text-shadow: 0px 2px 6px rgba(220,220,220,0.3);
    line-height: 17px;
    padding-left: 10px;
  }
}
.goods-bottom-icon {
  display: flex;
  padding-left: 3px;
  margin-top: 8px;

  p {
    font-size: 12px;
    padding: 1px 7px;
    // color: #FA0000;
    // background: #fff;
    // border: 1px solid #FA0000;
    // box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3), 0px 1px 2px 0px rgba(22, 124, 58, 0.1);
    color: #fff;
    background: #FF515A;
    box-shadow: 0px 2px 6px 0px rgba(220,220,220,0.3), 0px 1px 2px 0px rgba(181,2,14,0.1);
    border-radius: 3px;
    margin-right: 10px;
  }
}

.goods-zsm .badge {
  display: inline-block;
  padding: 1px 4px; // 内边距控制椭圆大小
  font-weight: bold; // 加粗字体
  font-size: 12px;
  color: #147A38; // 文字颜色
  background-color: #e6f7ee; // 可选背景色
  border-radius: 30px; // 椭圆形状
  border: 1px solid #b2eec7; // 可选边框
}

//金豆
.bean-icon {
  width: 20px;
  height: 20px;
  margin-right: 1px;
  vertical-align: text-bottom; // 改为底部对齐
}


</style>



// WEBPACK FOOTER //
// src/components/HomeComponents/HomeShop.vue